import React, { useState } from "react";
import { Badge, Button, Card } from "react-bootstrap";
import MaterialCard from "./MaterialCard";

const getSkillName = (skill) =>
  typeof skill === "string" ? skill : skill?.name || skill?.id || "";

const canInlinePreview = (type) =>
  ["pdf", "png", "jpg", "jpeg", "gif", "webp"].includes(String(type || "").toLowerCase());

export default function LearningMaterials({ materials }) {
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  const handleClose = () => setSelectedMaterial(null);

  return (
    <Card className="shadow mb-4 border-0">
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <Card.Title className="mb-0">Learning Materials</Card.Title>
          <Badge bg="light" text="dark" className="border">
            {materials.length} {materials.length === 1 ? "item" : "items"}
          </Badge>
        </div>

        {materials.length === 0 ? (
          <p className="text-center text-muted mb-0">No materials available yet.</p>
        ) : (
          <div className="row">
            {materials.map((item) => (
              <div key={item.id} className="col-md-6 col-xl-4 mb-3">
                <MaterialCard
                  material={item}
                  onView={setSelectedMaterial}
                  showAudienceBadge={false}
                />
              </div>
            ))}
          </div>
        )}

        {selectedMaterial && (
          <div className="mt-4 border-top pt-4">
            <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
              <div>
                <h5 className="mb-1">{selectedMaterial.title || selectedMaterial.fileName}</h5>
                <div className="d-flex flex-wrap gap-1">
                  {Array.isArray(selectedMaterial.skills) &&
                    selectedMaterial.skills.map((skill, idx) => (
                      <Badge bg="primary" key={skill.id || idx}>
                        {getSkillName(skill)}
                      </Badge>
                    ))}
                  {Array.isArray(selectedMaterial.tags) &&
                    selectedMaterial.tags.map((tag, idx) => (
                      <Badge bg="secondary" key={`${tag}-${idx}`}>
                        {tag}
                      </Badge>
                    ))}
                </div>
              </div>
              <Button variant="outline-secondary" size="sm" onClick={handleClose}>
                Close
              </Button>
            </div>

            {selectedMaterial.type === "video" ? (
              <video
                src={selectedMaterial.url}
                width="100%"
                height="400"
                controls
                className="rounded border"
              />
            ) : canInlinePreview(selectedMaterial.type) ? (
              <iframe
                src={selectedMaterial.url}
                width="100%"
                height="500px"
                title={selectedMaterial.title || selectedMaterial.fileName}
                className="rounded border"
              />
            ) : (
              <div className="border rounded p-4 text-center bg-light">
                <p className="mb-3 text-muted">
                  Preview is not available for this file type.
                </p>
                <a
                  href={selectedMaterial.url}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary"
                >
                  Open or Download
                </a>
              </div>
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
